export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14741.dba215f1.jpg";